import { getAnalytics, logEvent } from 'firebase/analytics';
import { getApp } from 'firebase/app';

export const firebaseErrorLogger = async (error: any, context: string, additionalData?: any) => {
    try {
        const analytics = getAnalytics(getApp());
        let processedData: Record<string, any> = {};
        if (additionalData && typeof additionalData === 'object') {
            for (const [key, value] of Object.entries(additionalData)) {
                let strValue = typeof value === 'string' ? value : JSON.stringify(value);
                if (strValue.length > 100) {
                    for (let i = 0; i < 20 && i * 100 < strValue.length; i++) {
                        processedData[`${key}_${i+1}`] = strValue.slice(i * 100, (i + 1) * 100);
                    }
                } else {
                    processedData[key] = strValue;
                }
            }
        }
        const errorData = {
            message: error instanceof Error ? error.message : String(error),
            stack: error instanceof Error ? error.stack : undefined,
            context,
            ...processedData
        };

        logEvent(analytics, 'frontend_error_occurred', errorData);

        console.error('Error logged to Firebase:', errorData);
    } catch (e) {
        console.error('Failed to log error to Firebase:', e);
        console.error('Original error:', error);
    }
};